import React from 'react'

// Static single-frame SVG. A 120° arc on a dim track ring, centred on a white dot.
// CSS `animation: ghLocSpin` on the parent element rotates this around its centre,
// so the arc orbits the dot without any JS per-frame work.
export default function LocationPinLoadingIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="15" stroke="#FAFAFA" strokeOpacity="0.3" strokeWidth="2.5" fill="none"/>
      <path d="M 17 2 A 15 15 0 0 1 30 24.5" stroke="#FAFAFA" strokeWidth="2.5" strokeLinecap="round" fill="none"/>
      <circle cx="17" cy="17" r="8" fill="#FAFAFA"/>
    </svg>
  )
}
